import * as cards from './frontend-functions/blog-list-cards';
import {cookiesMessage} from './frontend-functions/cookies-message';
import * as share from './frontend-functions/social-buttons';
import * as pwa from './pwa/pwa';
import 'lazysizes';

window.addEventListener('load', function() {
  cards.listCardsEffects();
  cookiesMessage();
  share.socialButtons();
  share.favoriteButton();
  share.upButton();
  pwa.registerServiceWorker();
});
